import { EventsActions, EventToastType, TOAST_TIMER_DEFAULT } from '@insync-students-constants/events';
import { IEventsState } from './eventsContext.types';
export interface ReducerAction {
  type: EventsActions;
  mainText?: string;
  actionTextLink?: string;
  icon?: string;
  onClick?: () => void;
  onClose?: () => void;
  eventToastType?: EventToastType;
  timer?: number;
  onAutoRedirect?: () => void;
  showToast?: boolean;
}

/**
 * eventsReducer
 * @param {IEventsState}          state      - Current Notifications Context state
 * @param {Action}                action     - Object with action to do and data to update
 */

export const eventsReducer = (state: IEventsState, action: ReducerAction) => {
  switch (action.type) {
    case EventsActions.OPEN_TOAST:
      {
        return {
          ...state,
          showToast: true,
          eventToastType: action.eventToastType,
          mainText: action.mainText,
          actionTextLink: action.actionTextLink,
          icon: action.icon,
          onClick: action.onClick,
          onClose: action.onClose,
          timer: action.timer || TOAST_TIMER_DEFAULT,
          onAutoRedirect: action.onAutoRedirect
        };
      }
    case EventsActions.CLOSE_TOAST:
      {
        return {
          ...state,
          showToast: false
        };
      }
    default:
      {
        throw new Error(`Unhandled action type: ${action.type}`);
      }
  }
};